const policy = require('./publicMediaUrlPolicy');

// Empty by default: activate only after legacy copies and the migration plan pass.
const publicBase = String(process.env.REACT_APP_PUBLIC_MEDIA_BASE_URL || '').trim();
const normalizePublicMediaUrl = value => policy.normalizePublicMediaUrl(value, publicBase);
const normalizePublicMediaValue = value => policy.normalizePublicMediaValue(value, publicBase);
const preparedIndexes = new WeakMap();

function resolvePreparedMediaAsset(entries, sourceUrl) {
  if (!entries || typeof entries !== 'object') return undefined;
  if (Object.prototype.hasOwnProperty.call(entries, sourceUrl)) return entries[sourceUrl];
  let index = preparedIndexes.get(entries);
  if (!index) {
    index = new Map();
    for (const [source, asset] of Object.entries(entries)) {
      const identity = policy.publicMediaIdentity(source);
      if (index.has(identity) && JSON.stringify(index.get(identity)) !== JSON.stringify(asset)) index.set(identity, null);
      else if (!index.has(identity)) index.set(identity, asset);
    }
    preparedIndexes.set(entries, index);
  }
  return index.get(policy.publicMediaIdentity(sourceUrl)) || undefined;
}

module.exports = { normalizePublicMediaUrl, normalizePublicMediaValue, resolvePreparedMediaAsset };
